import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import { AuthHead, AuthLoading, AuthPage } from '../../shared/sso-workspace/auth-card'
import { LegacyLaunchRedirect } from './legacy-redirect'

// The launch window is code-split (AGENTS.md Phase 6): it loads on learners'
// personal devices straight from the LMS, so it must not pay for the admin
// bundle.
const LayoutLaunch = React.lazy(() => import('./layout-launch'))

const launchFallback = (
  <AuthPage labelledBy="launch-title">
    <AuthHead id="launch-title" title="EducationXR" />
    <AuthLoading>Loading…</AuthLoading>
  </AuthPage>
)

// RouteLms hosts the learner-facing LMS Connector pages: the launch window at
// /lms/launch/:intent (Phase F F-12; not /launch, which would shadow
// mainline's /launch/content/:nodeID), logged-out capable, registered in both
// the auth and unauth route tables. /lms/launch?lt= and /link?lt= are the
// addresses packages built before Phase F open; they redirect to the window.
// The paths the app's route tables mount RouteLms on (page/layout.js).
export const LMS_LEARNER_PATHS = ['/link', '/lms/launch']

export const RouteLms = () => {
  return (
    <Switch>
      <Route path="/link" exact component={LegacyLaunchRedirect} />
      <Route path="/lms/launch" exact component={LegacyLaunchRedirect} />
      <Route path="/lms/launch/:intent">
        <Suspense fallback={launchFallback}>
          <LayoutLaunch />
        </Suspense>
      </Route>
    </Switch>
  )
}
